<template>
    <div class="dialog-modal-mask">
        <div class="small-panel">
            <div class="dialog-title-container">
                <div class="dialog-title">{{ $t("message.item_buddy_bot_api_get_token2") }}</div>
                <el-button class="sample-dialog-button" @click="showConfirmDialog">{{ $t("message.item_buddy_bot_api_regenerate_token") }}</el-button>
            </div>
            <hr class="dialog-hr">
            <div class="confirm-body">
                <span>{{ $t(this.displayName) }}{{ $t("message.item_buddy_bot_api_token_with_name") }}</span>
                <el-tooltip effect="dark" placement="left">
                    <div slot="content" style="text-align:left">{{ $t("message.desc_buddy_bot_api_token") }}</div>
                    <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                </el-tooltip>
                <br><br>
                <span style="word-wrap: break-word">{{ $t(this.token) }}</span>
                <br><br>
            </div>
            <hr class="dialog-hr">
            <div class="dialog-button-field">
                <el-button class="dialog-cancel-button" @click="$emit('close')" v-t="'message.button_close'"></el-button>
                <el-button class="dialog-ok-button" v-t="'message.item_buddy_bot_api_copy'" @click="copyToken"></el-button>
            </div>
        </div>
        <ConfirmTokenRegenerate v-if="isConfirmDialogOpen" @cancel="isConfirmDialogOpen=false" @execute="regenerateToken"></ConfirmTokenRegenerate>
    </div>
</template>

<script>
import commonUtil from "../../../commonutil";
import server from "../../../ServerApi";
import constants from "../../../constants";
import ConfirmTokenRegenerate from "./ConfirmTokenRegenerate.vue";

export default {
    props: ['tokenInfo'],
    data() {
        return {
            isConfirmDialogOpen: false,

            id: null,
            displayName: null,
            token: null,
        };
    },
    created: function () {
        this.id = this.tokenInfo.id;
        this.displayName = this.tokenInfo.displayName;
        this.token = this.tokenInfo.token;
    },
    methods: {
        async copyToken() {
            try {
                await navigator.clipboard.writeText(this.token);
                commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_buddy_bot_api_copy_success"));
            } catch (error) {
                commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "info_buddy_bot_api_copy_failed"));
            }
        },
        regenerateToken() {
            this.isConfirmDialogOpen = false;
            server.post('/getassistanttoken', {
                objectId: this.id,
                shouldRegenerate: true,
            }).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_buddy_bot_api_regenerate_token_success"));
                        this.token = res.data.token;
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_access_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "getAssistantToken").replace("{code}", res.data.status));
                        break;
                }
            }).catch(function (error) {
                commonUtil.putExceptionErrorMessage(this, "getAssistantToken", error);
            })
        },
        showConfirmDialog() {
            this.isConfirmDialogOpen = true;
        },
    },
    components: {ConfirmTokenRegenerate},
};
</script>

<style scoped>
.dialog-modal-mask {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}

.small-panel {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
    width: 400px;
}

.dialog-title {
    display: flex;
    align-items: center;
    height: 100%;
    text-align: left;
}

.dialog-title-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dialog-hr {
    margin: 10px 0;
    border: none;
    border-top: 1px solid #ccc;
}

.confirm-body {
    font-size: 14px;
    color: #333;
}

.dialog-button-field {
    text-align: right;
}

.dialog-ok-button {
    background-color: #5171cb;
    color: white;
}
</style>
